import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function Stamp({ mainText, subText, variant }) {
  return (
    <svg
      className={classNames('stamp', variant)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-940 962 122 76.64"
      width="208"
      height="130"
      data-variant={variant}
    >
      <g>
        <path
          d="M-920.1,1014.9c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0.1,0.1,0.1C-920,1015.1-920,1015-920.1,1014.9z"
        />
        <path
          d="M-919.9,1008.9C-919.9,1008.9-919.9,1008.8-919.9,1008.9C-919.9,1008.8-919.9,1008.8-919.9,1008.9   L-919.9,1008.9z"
        />
        <path
          d="M-918.1,1012.8c-0.1,0-0.1-0.1-0.2-0.2l0,0c-0.9,0-0.3,0.3-0.5,0.5c0.3,0,0.6,0,0.8-0.1   C-918,1013-918,1012.9-918.1,1012.8C-918,1012.8-918.1,1012.8-918.1,1012.8z"
        />
        <path d="M-918.8,1011.5L-918.8,1011.5L-918.8,1011.5z" />
        <path
          d="M-918.8,1011.5L-918.8,1011.5c-0.3-0.4-0.6-0.6-0.9-0.7c-0.1,0-0.2,0-0.2,0.1   C-919.4,1011.2-919.1,1011.3-918.8,1011.5z"
        />
        <path
          d="M-921.4,1009.9c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7C-921.9,1009.3-921.5,1009.6-921.4,1009.9z"
        />
        <path
          d="M-921.7,1008.1c-0.2,0.1-0.4,0.1-0.5,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0,0.2,0,0.3,0   C-921.8,1008.5-921.8,1008.4-921.7,1008.1z"
        />
        <path d="M-916.3,1013.8v0.3c0-0.1,0.1-0.2,0.1-0.3C-916.3,1013.8-916.3,1013.8-916.3,1013.8z" />

        <path
          d="M-915.1,1013.4c-0.5,0.1-0.9,0.1-1.3,0.1v0.3h0.1c0,0.1,0,0.1-0.1,0.3l0,0c0.5-0.2,0.8-0.3,1.3-0.5   C-915,1013.7-915,1013.5-915.1,1013.4z"
        />
        <path
          d="M-915.7,1013.1c0-0.3-0.1-0.6-0.1-0.9c-0.2,0.1-0.4,0.1-0.6,0.2v0.3c0.2,0.1,0.4,0.3,0.5,0.4   C-915.9,1013.1-915.8,1013.1-915.7,1013.1z"
        />
        <path d="M-915.6,1003.3c0.1,0.2,0.1,0.4,0.2,0.7C-914.6,1003.7-914.6,1003.6-915.6,1003.3z" />
        <path
          d="M-909.3,1012.3c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-1.2,0.1-0.6,0.7C-909.8,1012.7-909.6,1012.5-909.3,1012.3z"
        />

        <path
          d="M-896.4,1000.8c0,0.1,0.2,0.3,0.1,0.4c-0.2,0.1-0.3,0.3-0.2,0.4c0.2-0.2,0.4-0.5,0.5-0.9   C-896.1,1000.8-896.3,1000.8-896.4,1000.8L-896.4,1000.8z"
        />

        <path d="M-885.5,996c0.1-0.1,0.1-0.1,0.2-0.2l-0.1-0.4C-885.6,995.6-885.7,995.8-885.5,996z" />
        <path d="M-885.5,996L-885.5,996L-885.5,996L-885.5,996z" />

        <path d="M-881.3,995.9L-881.3,995.9L-881.3,995.9L-881.3,995.9z" />
        <path
          d="M-883.3,993.5c0.1,0,0.2-0.1,0.3-0.1c0-0.1,0-0.2-0.1-0.2c-0.4-0.1-0.8-0.1-1.3-0.2c0.3,0.2,0.4,0.3,0.7,0.5   C-883.8,993.6-883.5,993.6-883.3,993.5z"
        />

        <path
          d="M-875.5,995.5c0-0.1,0-0.2,0-0.2c-0.3,0.1-0.6,0.1-1,0.2c0,0.2-0.1,0.5-0.1,0.8c0.5-0.1,0.8-0.2,1.2-0.3   c-0.1,0.2-0.1,0.2-0.1,0.3c0.7,0,0.1-0.7,0.8-0.6c0-0.1,0-0.2-0.1-0.2C-875.1,995.5-875.3,995.6-875.5,995.5z"
        />
        <path
          d="M-876,996.8c-0.1,0,0,0.2,0,0.2c0.5-0.1,0.9-0.1,1.3-0.2c0-0.1,0-0.2,0-0.3   C-875.2,996.6-875.6,996.7-876,996.8z"
        />

        <path d="M-896.5,1027.3l-0.4,0.1c0.2,0,0.4,0.1,0.6,0.1C-896.4,1027.4-896.4,1027.3-896.5,1027.3z" />
        <path
          d="M-818.3,994.8l-10.1-27.7c-1.3-3.5-5.2-5.3-8.7-4l-7.2,2.6c0.4,0.2,0.9,0.3,1.3,0.5c-0.3,0.2-0.7,0.3-1.2,0.6   c1.1,0.3,0.9,0.9,0.6,1.4c-0.1-0.2-0.2-0.4-0.2-0.6l-0.1,0.1c-0.3-0.2-0.6-0.3-1-0.5c0,0.1-0.1,0.2-0.2,0.4   c-0.4-0.5-0.5-0.9-0.4-1.4l-26.2,9.5c0.1,0.1,0.3,0.1,0.3,0.2c0.3,0.2,0.4,0.5,0.6,0.8l0,0c-0.1,0.1-0.3,0.3-0.5,0.5   c0-0.3,0-0.5,0-0.9c-0.3,0.4-0.7,0.4-1.4,0c0.2-0.1,0.4-0.1,0.7-0.3c-0.3,0-0.4,0-0.7,0l-1.5,0.5l0,0c0,0,0.1,0,0.2,0.1   c0.6,0.2,1.3,0.4,1.9,0.5l-0.1,0.1c-0.6,0.1-1.2,0.2-1.8,0.3c0,0.2,0,0.4,0,0.6c-0.5,0-0.8-0.1-1.3-0.1c-0.1-0.1-0.8-0.3-0.2-0.6   c0.3,0.1,0.5,0.1,0.8,0.2c-0.1-0.3-0.1-0.3-1.3-0.3c0,0,0,0,0-0.1l-58.6,21.3c-3.5,1.3-5.3,5.2-4,8.7l10.1,27.7   c1.3,3.5,5.2,5.3,8.7,4l74.2-27c-0.5-0.3-0.9-0.7-1.4-1c0.1,0,0.1-0.1,0.2-0.1c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.3-0.3,0.5-0.5   c0.2,0.1,0.4,0.2,0.5,0.2c0.2,0,0.5,0.1,0.5,0.1c0.5-0.4,1-0.1,1.4,0c0.1,0,0.2,0,0.4,0c-0.1-0.1-0.2-0.2-0.2-0.3   c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.2,0.4,0.4l19.9-7.3C-818.9,1002.2-817.1,998.3-818.3,994.8z M-842.4,965.7c0.4,0,0.7,0,1.1,0   c-0.2,0.2-0.4,0.5-0.6,0.7C-842.7,966.2-842.9,966-842.4,965.7z M-877.1,1022.4c-0.4,0-0.8-0.1-1.2-0.2c-0.3,0.1-0.5,0.2-0.8,0.3   c-0.1-0.1-0.4-0.1-0.4-0.2c-0.1-0.1,0-0.2,0.1-0.4c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.4,0.2,0.7,0.3l0,0l0,0c-0.1-0.1-0.2-0.2-0.4-0.2   c0.2-0.1,0.3-0.3,0.5-0.4c0.1,0.2,0.2,0.5,0.4,0.6c0.2,0.1,0.6,0,1.1,0C-876.5,1022.2-876.7,1022.4-877.1,1022.4z M-876.5,1023.2   c0.1-0.5,0.1-1,0.2-1.5C-875.5,1022.2-876.1,1022.7-876.5,1023.2z M-823.4,1000.6l-71.8,26.1c0.5,0.1,0.9,0.3,1.4,0.4l-0.1,0.1   c-0.6,0.1-1.2,0.2-1.8,0.3c0,0.2,0,0.4,0,0.6c-0.5,0-0.8-0.1-1.3-0.1c-0.1-0.1-0.5-0.2-0.4-0.4l-23.2,8.5c-1.9,0.7-4.1-0.3-4.8-2.2   l-10.1-27.7c-0.7-1.9,0.3-4.1,2.2-4.8l32.5-11.8v-0.1c0.1,0,0.1,0,0.1,0.1l32-11.7c-0.1-0.1-0.2-0.2-0.3-0.3c0.5,0,0.9-0.1,1.3-0.1   l11.5-4.2c-0.1-0.2-0.2-0.3-0.2-0.5c0.4,0,0.7,0,1.1,0c-0.1,0.1-0.2,0.2-0.3,0.3l19.3-7c1.9-0.7,4.1,0.3,4.8,2.2l6.4,17.5   c0.3,0,0.6,0.1,0.9,0.2c0.6,0,1.2-0.2,1.5,0.3c-0.3,0.2-0.5,0.4-0.6,0.5c-0.5,0.1-0.9,0.1-1.4,0.2l3.3,9.2   C-820.5,997.8-821.5,999.9-823.4,1000.6z"
        />
        <path d="M-876.3,1021.7c-0.1,0.5-0.1,1-0.2,1.5C-876.1,1022.7-875.5,1022.2-876.3,1021.7z" />
        <path
          d="M-877.8,1022.1c-0.2-0.1-0.3-0.4-0.4-0.6c-0.2,0.1-0.3,0.3-0.5,0.4c0.1,0.1,0.3,0.2,0.4,0.2l0,0   c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0,0.7-0.1,0.5-0.3C-877.1,1022.1-877.6,1022.2-877.8,1022.1z"
        />
        <path
          d="M-879,1021.9c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1-0.1,0.3-0.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2   c0.3-0.1,0.6-0.2,0.8-0.3l0,0C-878.5,1022.1-878.7,1022-879,1021.9z"
        />
        <path
          d="M-842.9,1010.4c0.1,0.1,0.1,0.2,0.2,0.3c-0.2,0-0.3,0-0.4,0c-0.5-0.1-0.9-0.5-1.4,0c0,0-0.3,0-0.5-0.1   s-0.3-0.1-0.5-0.2c-0.2,0.2-0.3,0.4-0.5,0.5c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.7,1.4,1l3-1.1   c-0.1-0.1-0.3-0.3-0.4-0.4C-842.7,1010.4-842.8,1010.4-842.9,1010.4z"
        />
        <path
          d="M-823.1,986.5c0.1-0.1,0.3-0.3,0.6-0.5c-0.3-0.5-1-0.3-1.5-0.3c-0.3-0.1-0.6-0.2-0.9-0.2l0.4,1.1   C-824,986.6-823.6,986.6-823.1,986.5z"
        />
        <path d="M-900.7,989.3L-900.7,989.3l0.1,0.1L-900.7,989.3z" />
      </g>
      <text
        x="-1220"
        y="638"
        className="mainText"
        textLength="86%"
        lengthAdjust="spacingAndGlyphs"
      >
        {mainText}
      </text>
      <text
        x="-1220"
        y="654"
        className="subText"
        textLength="86%"
        lengthAdjust="spacingAndGlyphs"
      >
        {subText}
      </text>
    </svg>
  );
}

Stamp.propTypes = {
  mainText: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'success',
    'warning',
    'danger',
    'info',
    'default',
  ]),
};

Stamp.defaultProps = {
  variant: 'default',
};
export default Stamp;
